export enum QxAction {
    NOTHING,
    DELETE
}
